import { IUser } from "src/app/users-manager/interfaces/user.interface";

export interface IUserConnectedDto {
    username: string;
}

export interface IUserLoginDto {
  username: string;
  password: string;
}

export interface IUserPwdResetDto {
    idUser: number;
    password: string;
}

export interface UserResetPasswordWithCode {
    requestCode: string;
    newPassword: string;
}

export interface IUserRegistrationDto {
    languageCode: string;
    username: string;
    password: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    idCountry: number;
    activeWithSMS: boolean;
    idEvent: number | null;
    signUpPath: string;
    phoneData?: {
        country: string;
        dialCode: string;
        e164Number: string;
        internationalNumber: string;
        nationalNumber: string;
        number: string;
        numberExtension: string;
        possible: boolean;
        valid: boolean;
    };
}

export interface IUserEventRegistrationDto extends IUserRegistrationDto {
    idEvent: number | null;
}

export interface IUserActivationDto {
    activationCode: string;
}

export interface IUserAuthenticateRequest {
    authResult: number;
    user: UserLogged;
    signUpPath?: string;
}

export class UserLogged implements IUser {
    idUser: number;
    username: string;
    email: string;
    phone: string;
    idProfile: number;
    isBanned: boolean;
    isEnabled: boolean;
    isActivated: boolean;
    activatedOn: string | null;
    activationGuid: string;
    idEntity: number;
    entityFullName: string;
    password: string;

    constructor(
        idUser: number,
        username: string,
        email: string,
        phone: string,
        idProfile: number,
        isBanned: boolean,
        isEnabled: boolean,
        isActivated: boolean,
        activatedOn: string | null,
        activationGuid: string,
        idEntity: number,
        entityFullName: string,
    ) {
        this.idUser = idUser;
        this.username = username;
        this.email = email;
        this.phone = phone;
        this.idProfile = idProfile;
        this.isBanned = isBanned;
        this.isEnabled = isEnabled;
        this.isActivated = isActivated;
        this.activatedOn = activatedOn;
        this.activationGuid = activationGuid;
        this.idEntity = idEntity;
        this.entityFullName = entityFullName;
    }
}
